import { Report as ActionTypes } from '../actionTypes';

const initialState = {
  data: [],
  override: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.CREATE:
      return {
        ...state,
        data: [
          ...state.data,
          payload,
        ],
      };
    case ActionTypes.OVERRIDE:
      return {
        ...state,
        data: payload,
        override: true,
      };
    case ActionTypes.REMOVE:
      return {
        ...state,
        data: state.data.filter(item => item.Name !== payload),
      };
    case ActionTypes.UPDATE:
      return {
        ...state,
        data: state.data.reduce((list, item) => {
          if (item.Name === payload.Report) {
            list.push({ ...item, ...payload.Data });
          } else {
            list.push(item);
          }
          return list;
        }, []),
      };
    default:
      return state;
  }
};
